/**
 * Спільний сигнал для ретеншн-офера: який попап зараз відкритий.
 *
 * Модалки монтуються глобально (<RetentionOfferModals /> у корені App), а
 * відкриваються з будь-якого місця: після «Все одно вимкнути», коли сервер
 * УЖЕ вимкнув автопродовження (owner 2026-10-22), АБО тап по закрепу в
 * стрічці / на головній / у підписці, АБО кнопка з нагадування в боті.
 *
 * Module-level (не React-state) — щоб незалежні компоненти (закреп у різних
 * розділах і глобальні модалки) бачили один прапор без спільного провайдера.
 * Той самий патерн, що activationGate.ts.
 *
 * step:
 *   "offer"    — офер із закрепу / бота: якщо автопродовження вже вимкнене,
 *                показується той самий стан, що й "reminder"
 *   "reminder" — «Автопродовження вимкнено, але спецпропозиція ще діє»
 *   null       — закрито
 */

export type RetentionStep = "offer" | "reminder" | null;

let _step: RetentionStep = null;
const subs = new Set<(s: RetentionStep) => void>();

export function openRetentionOffer(
  step: Exclude<RetentionStep, null> = "offer",
): void {
  _step = step;
  subs.forEach((fn) => fn(_step));
}

export function closeRetentionOffer(): void {
  if (_step === null) return;
  _step = null;
  subs.forEach((fn) => fn(_step));
}

export function subscribeRetentionOffer(
  fn: (s: RetentionStep) => void,
): () => void {
  subs.add(fn);
  fn(_step);
  return () => {
    subs.delete(fn);
  };
}
